//@ts-ignore
import React, { useState, Component } from "react";
import {
  createStyles
} from "@material-ui/core/styles";
import { WithStyles, withStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import FormControl from "@material-ui/core/FormControl";
import Typography from "@material-ui/core/Typography";
import NativeSelect from "@material-ui/core/NativeSelect";
import InputBase from "@material-ui/core/InputBase";

const styles = (theme: Theme) => createStyles({

  input: {
    minWidth: '18px',
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 16,
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    padding: '0',
    borderRadius: '5px',
    marginRight: '10px',
    "&:focus": {
      borderRadius: 4,
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)"
    },
    "&::-webkit-inner-spin-button": {
      "opacity": "revert",
    },
    "&::-webkit-outer-spin-button": {
      "opacity": "revert",
    },
    "& select": {
      padding: '10px 20px 10px 27px',
      width: '100%',
      height: '45px',
      boxSizing: 'border-box',
      minWidth: '75px',
      scrollbarWidth: 'thin',
      scrollbarColor: '#bdbdbd #999999',
      "&::-webkit-scrollbar": {
        width: '5px',
      },
      "&::-webkit-scrollbar-track": {
        background: '#999999',
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: '#bdbdbd',
        borderRadius: '10px',
        border: '0px solid #ffffff',
      },
    },
  },
  timerLabel: {
    textAlign: 'center',
    marginRight: '10px',
    paddingTop: '5px',
    color: '#B2B2B2',
  },
})

interface TimePickerProps extends WithStyles<typeof styles> {
  classes: any,
  value: any,
  onChange: Function,
  videoDuration: any,

}

interface TimePickerState {
  hoursArr: any,
  minArr: any,
  secondsArray: any
}

class TimePicker extends Component<TimePickerProps, TimePickerState>{
  constructor(props: TimePickerProps) {
    super(props);
    const { videoDuration, value, onChange } = this.props;
    const videoDurationSplit = videoDuration.split(':');
    const videoMin = (videoDurationSplit && videoDurationSplit[1] <= 9 && videoDurationSplit[1] !== '00') ? `0${videoDurationSplit[1]}` : videoDurationSplit[1];

    const videoHrs = (videoDurationSplit && videoDurationSplit[0] <= 9 && videoDurationSplit[0] !== '00') ? `0${videoDurationSplit[0]}` : videoDurationSplit[0];
    console.log({videoHrs},{videoVal:value.split(':')[0]},videoMin,value.split(':')[1]);
    let initialSecVal = (value !== '00:00:00' && videoMin === value.split(':')[1] && videoHrs === value.split(':')[0] )?videoDuration.split(':')[2]: (value !== '00:00:00' && (videoMin !== value.split(':')[1] || videoHrs !== value.split(':')[0]) )?59:videoDuration.split(':')[2];
    
    this.state = {
      hoursArr: this.getTimeArray(videoDuration.split(':')[0]),
      minArr: this.getTimeArray(videoDuration.split(':')[1]),
      secondsArray: this.getTimeArray(initialSecVal)
    };
    
    this.setDefaultValue(videoHrs,videoMin);
  }

  setDefaultValue = (videoHrs:any,videoMin:any) => {
    const { videoDuration, value, onChange } = this.props;

    let timeString = '00:00:00';
    if(value === '00:00:00'){
      let seconds = (videoDuration.split(':')[2] <= 9) ? `0${videoDuration.split(':')[2]}` : `${videoDuration.split(':')[2]}`;
       timeString = `${videoHrs}:${videoMin}:${seconds}`;
    }else{
      timeString = value;
    }
    console.log({timeString});
    onChange(timeString);
  }

  getTimeArray = (hoursNum: any) => {
    const hrArr = Array.from({ length: Number(hoursNum) + 1 }, (v, k) => {
      return (k <= 9) ? `0${k}` : `${(k)}`;
    });
    return hrArr;
  }

  handleTime = (key: string) => (event: any) => {
    const { videoDuration, value, onChange } = this.props;
    const videoDurationSplit = videoDuration.split(':');
    const videoMin = (videoDurationSplit && videoDurationSplit[1] <= 9 && videoDurationSplit[1] !== '00') ? `0${videoDurationSplit[1]}` : videoDurationSplit[1];
    const videoHrs = (videoDurationSplit && videoDurationSplit[0] <= 9 && videoDurationSplit[0] !== '00') ? `0${videoDurationSplit[0]}` : videoDurationSplit[0];
    const timeSplit = value.split(':');

    const newTime = {
      hours: timeSplit[0] || '00',
      min: timeSplit[1] || '00',
      sec: ((key === 'min' && videoMin === event.target.value) ? "00" : timeSplit[2]) || '00',
      [key]: `${event.target.value}`
    }

    if (((key === 'min' && videoMin === event.target.value) || (key === 'sec' && value.split(':')[1] === videoMin)) && videoHrs === timeSplit[0]) {
      this.setState({ secondsArray: this.getTimeArray(videoDurationSplit[2]) });
    } else {
      this.setState({ secondsArray: this.getTimeArray(59) });
    }

    const timeString = `${newTime.hours}:${newTime.min}:${newTime.sec}`;
    onChange(timeString);
  }

  render = () => {
    const { classes, value, videoDuration } = this.props;
    const { hoursArr, minArr, secondsArray } = this.state;
    return (
      <div className={classes.textCenter}>
        <FormControl>
          <NativeSelect
            id="demo-customized-select-native"

            onChange={() => this.handleTime('hours')}
            input={<InputBase className={classes.input} />}
            defaultValue={value.split(':')[0] === "00" ? ((hoursArr.length <= 10) ? `0${hoursArr.length - 1}` : `${hoursArr.length - 1}`) : value.split(':')[0]}
          >
            {!hoursArr.length ? <option value='00'>00</option> : hoursArr.map((i: any) => (
              <option value={i} >{i}</option>

            ))}
          </NativeSelect>
          <Typography className={classes.timerLabel}>Hr</Typography>
        </FormControl>
        <FormControl className={classes.margin}>
          <NativeSelect
            id="demo-customized-select-native"

            onChange={this.handleTime('min')}
            input={<InputBase className={classes.input} />}
            defaultValue={(value.split(':')[1] === "00") ? ((minArr.length <= 10) ? `0${minArr.length - 1}` : `${minArr.length - 1}`) : value.split(':')[1]}

          >
            {!minArr.length ? <option value='00'>00</option> : minArr.map((i: any) => (
              <option value={`${i}`}>{i}</option>
            ))}
          </NativeSelect>
          <Typography className={classes.timerLabel}>Min</Typography>
        </FormControl>
        <FormControl className={classes.margin}>
          <NativeSelect
            onChange={this.handleTime('sec')}
            input={<InputBase className={classes.input} />}
            defaultValue={(value === "00:00:00") ? ((secondsArray.length <= 10) ? `0${secondsArray.length - 1}` : `${secondsArray.length - 1}`) : value.split(':')[2]}
          >
            {!secondsArray.length ? <option value='00'>00</option> : secondsArray.map((i: any) => (
              <option value={i}>{i}</option>
            ))}
          </NativeSelect>
          <Typography className={classes.timerLabel}>Sec</Typography>

        </FormControl>
      </div>
    )

  }
}
// @ts-ignore 
export default withStyles(styles)(TimePicker);